import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../pages/HomePage'
import RegisterPage from '../pages/RegisterPage'
import VerifyPage from '../pages/VerifyPage'
import UserVisitsPage from '../pages/UserVisitsPage'
import VisitSuccessPage from '../pages/VisitSuccessPage'
import UserVisitsSectorPage from '../pages/UserVisitsSectorPage'
import UserVisitExitPage from '../pages/UserVisitExitPage'
import UserVisitPreValidationPage from '../pages/UserVisitPreValidationPage'
import ReSendQRCodePage from '../pages/ReSendQRCodePage'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',

    component: () => import('@/layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'HomePage',
        component: HomePage
      },
      {
        path: 'register',
        name: 'RegisterPage',
        component: RegisterPage
      },
      {
        path: 'verify/:token',
        props:true,
        name: 'VerifyPage',
        component: VerifyPage
      },
      {
        path: 'visit-success',
        name: 'VisitSuccessPage',
        component: VisitSuccessPage
      },
      {
        path: 'user-visit-pre-validation',
        name: 'UserVisitPreValidationPage',
        component: UserVisitPreValidationPage
      },
      {
        path: 'visits',
        name: 'UserVisitsPage',
        component: UserVisitsPage
      },
      {
        path: 'sectors/:sector/',
        props: true,
        name: 'UserVisitsSectorPage',
        component: UserVisitsSectorPage
      },
      {
        path: 'exit',
        props: true,
        name: 'UserVisitExitPage',
        component: UserVisitExitPage
      },
      {
        path: 'resend-qr-code',
        name: 'ReSendQRCodePage',
        component: ReSendQRCodePage
      },
      {
        path: '*',
        redirect: '/'
      },
    ]
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
